module.exports = __webpack_public_path__ + "img/Email-template_background.51ff09a9.jpg";